/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ GlobalDrawer)
/* harmony export */ });
class GlobalDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll('[data-drawer-close]');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeAllDrawers = this.closeAllDrawers.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-drawer'});
    window.eventBus.on('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => {
      element.addEventListener('click', this.closeDrawer);
    });

    if (window.Shopify.designMode) {
      window.addEventListener('resize', this.handleResize);
    }
  }

  openDrawer() {
    window.eventBus.emit('close:all:drawers', this); // Close all other global drawers before opening this one
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-drawer-open'); // Lock scroll
    this.addEventListener('transitionend', this.handleTransitionEnd);
    // Emit event when drawer opens
    window.eventBus.emit('drawer:opened', this);
  }

  closeDrawer() {
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-drawer-open'); // Unlock scroll
    this.removeEventListener('transitionend', this.handleTransitionEnd);
    // Emit event when drawer closes
    window.eventBus.emit('drawer:closed', this);
  }

  closeAllDrawers(e) {
    if (e === this) return; // Only close other drawers not this one
    this.closeDrawer();
  }

  handleTransitionEnd(e) {
    // Trap focus once drawer is fully open
    if (e.target === this) {
      this.trapFocus();
    }
  }

  trapFocus() {
    const focusableElements = this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    firstFocusableElement.focus();
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  handleResize() {
    this.classList.add('disable-transitions');
    setTimeout(() => {
      this.classList.remove('disable-transitions');
    }, 500);
  }

  disconnectedCallback() {
    if (window.Shopify.designMode) {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5669);


class SearchDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A {
  constructor() {
    super();
    this.predictiveSearch = this.querySelector('predictive-search');
    this.input = this.querySelector('[data-predictive-search-input]');
    this.triggerElement = null;
    this.productsLoaded = false;
    this.recentBlock = this.querySelector('[data-search-drawer-recent]');
    this.recentList = this.querySelector('[data-search-drawer-recent-list]');
    this.recentClear = this.querySelector('[data-search-drawer-recent-clear]');
    this.resultsContainer = this.querySelector('[data-predictive-search-results]');
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.handleFocusKeyDown = this.handleFocusKeyDown.bind(this);
    this.clearRecentSearches = this.clearRecentSearches.bind(this);
    this.handleResultClick = this.handleResultClick.bind(this);
    this.fitProducts = this.fitProducts.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    window.wetheme.webcomponentRegistry.register({key: 'component-search-drawer'});

    // The header search buttons emit this from theme.js; the dropdown is not rendered when the drawer is
    window.eventBus.on('toggle:search:dropdown', this.toggleDrawer);
    window.eventBus.on('close:search:dropdown', this.closeDrawer);
    this.addEventListener('keydown', this.handleFocusKeyDown);
    if (this.recentClear) this.recentClear.addEventListener('click', this.clearRecentSearches);
    if (this.resultsContainer) this.resultsContainer.addEventListener('click', this.handleResultClick);
    window.addEventListener('resize', this.handleWindowResize);

    this.recordCurrentSearch();
  }

  toggleDrawer(e) {
    if (this.getAttribute('aria-hidden') === 'false') {
      this.closeDrawer();
      return;
    }
    this.triggerElement = e && e.currentTarget instanceof HTMLElement ? e.currentTarget : document.activeElement;
    this.openDrawer();
    // theme [data-animate] items (predictive product cards) only reveal under .shown-on-scroll, as in search-dropdown
    this.classList.add('shown-on-scroll');
    this.renderRecentSearches();
    this.loadProducts();
    this.fitProducts();
  }

  // Recent searches: this browser only (localStorage), newest first. Two ways in: landing on /search?q=
  // (Enter, suggestion links, "View all results") records its own query, and clicking a typed result
  // that skips the search page (product, collection, page, article) records the typed text.
  getRecentSearches() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(SearchDrawer.RECENT_KEY) || '[]');
      return Array.isArray(stored) ? stored.filter((term) => typeof term === 'string') : [];
    } catch (error) {
      return [];
    }
  }

  saveRecentSearches(terms) {
    try {
      if (terms.length) {
        window.localStorage.setItem(SearchDrawer.RECENT_KEY, JSON.stringify(terms));
      } else {
        window.localStorage.removeItem(SearchDrawer.RECENT_KEY);
      }
    } catch (error) {
      // storage blocked (private mode etc.): recents just don't persist
    }
  }

  recordCurrentSearch() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    // the predictive submit appends '*' for prefix matching; store the term as typed
    this.addRecentSearch((new URLSearchParams(window.location.search).get('q') || '').replace(/\*+$/, ''));
  }

  handleResultClick(e) {
    const link = e.target.closest('a[href]');
    if (!link || !this.input) return;
    // links to /search record themselves when that page loads
    if (/\/search\/?$/.test(new URL(link.href, window.location.href).pathname)) return;
    this.addRecentSearch(this.input.value);
  }

  addRecentSearch(value) {
    const term = (value || '').trim();
    if (!term) return;

    const recent = this.getRecentSearches().filter((item) => item.toLowerCase() !== term.toLowerCase());
    recent.unshift(term);
    this.saveRecentSearches(recent.slice(0, SearchDrawer.RECENT_LIMIT));
  }

  renderRecentSearches() {
    if (!this.recentBlock || !this.recentList) return;
    const recent = this.getRecentSearches();

    this.recentList.replaceChildren(...recent.map((term) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'search-drawer__term';
      link.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(term)}*`;
      link.textContent = term;
      item.appendChild(link);
      return item;
    }));
    this.recentBlock.hidden = recent.length === 0;
  }

  clearRecentSearches() {
    this.saveRecentSearches([]);
    this.renderRecentSearches();
    this.fitProducts();
    if (this.input && window.matchMedia('(hover: hover)').matches) this.input.focus();
  }

  // Empty-state Trending list (last-14-days metafield or best-selling) comes from sections/search-drawer-products.liquid
  // via the Section Rendering API, fetched once on first open so page loads don't pay for them
  loadProducts() {
    if (this.productsLoaded) return;
    this.productsLoaded = true;

    this.querySelectorAll('[data-search-drawer-products-url]').forEach(async (block) => {
      const slot = block.querySelector('[data-search-drawer-products-slot]');
      try {
        const response = await fetch(block.dataset.searchDrawerProductsUrl);
        if (!response.ok) throw new Error(`${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = html.querySelector('[data-search-drawer-products-list]');
        if (!list || !list.children.length) throw new Error('empty');
        slot.replaceChildren(list);
        this.fitProducts();
      } catch (error) {
        block.setAttribute('hidden', '');
      }
    });
  }

  // The theme setting is a maximum: rows that would run past the bottom of the drawer are hidden so the
  // list ends on a whole row instead of scrolling (at least one row always shows). Re-run whenever the
  // space changes: list loaded, drawer opened (Recent may have grown), Recent cleared, window resized.
  fitProducts() {
    const panel = this.querySelector('.global-drawer__content');
    const body = this.querySelector('.search-drawer__body');
    if (!panel || !body) return;

    const lists = this.querySelectorAll('.search-drawer__empty-state .search-drawer__products');
    lists.forEach((list) => list.querySelectorAll(':scope > li').forEach((row) => { row.hidden = false; }));

    const panelRect = panel.getBoundingClientRect();
    if (!panelRect.height) return;
    const limit = Math.min(panelRect.bottom, window.innerHeight) - parseFloat(getComputedStyle(body).paddingBottom || 0);

    lists.forEach((list) => {
      if (!list.getBoundingClientRect().height) return; // empty state hidden while results show
      list.querySelectorAll(':scope > li').forEach((row, index) => {
        if (index > 0 && row.getBoundingClientRect().bottom > limit) row.hidden = true;
      });
    });
  }

  handleWindowResize() {
    if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = requestAnimationFrame(this.fitProducts);
  }

  closeDrawer() {
    const wasOpen = this.getAttribute('aria-hidden') === 'false';
    super.closeDrawer();
    this.classList.remove('shown-on-scroll');
    if (!wasOpen) return;

    this.resetSearch();

    if (this.triggerElement && document.body.classList.contains('using-keyboard')) {
      this.triggerElement.focus();
    }
    this.triggerElement = null;
  }

  // Back to the Trending / Best Sellers empty state for the next open
  resetSearch() {
    if (!this.predictiveSearch || !this.input || this.input.value === '') return;
    this.input.value = '';
    this.predictiveSearch.searchQuery = '';
    this.predictiveSearch.handleClearButtonVisibility();
    this.predictiveSearch.resetState();
  }

  // Replaces GlobalDrawer.trapFocus: only focus the input on hover devices so phones don't pop the keyboard,
  // and keep the Tab-wrap listener single (added once in connectedCallback)
  trapFocus() {
    if (window.matchMedia('(hover: hover)').matches && this.input) {
      this.input.focus();
    } else {
      const closeButton = this.querySelector('.global-drawer__close');
      if (closeButton) closeButton.focus({preventScroll: true});
    }
  }

  handleFocusKeyDown(e) {
    if (e.key !== 'Tab' || this.getAttribute('aria-hidden') !== 'false') return;
    const focusableElements = Array.from(this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(element => !element.closest('[hidden]') && !element.classList.contains('hide') && element.offsetParent !== null);
    if (focusableElements.length === 0) return;
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.eventBus.off('toggle:search:dropdown', this.toggleDrawer);
    window.eventBus.off('close:search:dropdown', this.closeDrawer);
    this.removeEventListener('keydown', this.handleFocusKeyDown);
    if (this.recentClear) this.recentClear.removeEventListener('click', this.clearRecentSearches);
    if (this.resultsContainer) this.resultsContainer.removeEventListener('click', this.handleResultClick);
    window.removeEventListener('resize', this.handleWindowResize);
  }
}

SearchDrawer.RECENT_KEY = 'gf-recent-searches';
SearchDrawer.RECENT_LIMIT = 5;

if (!customElements.get('search-drawer')) {
  customElements.define('search-drawer', SearchDrawer);
}

/******/ })()
;
